<template>
  <div class="slide">
    <div class="centertext is-hidden-mobile">
      <div class="logo">
        <img src="../assets/logow.svg"/>
      </div>
      <div class="head title">
        Lékárna <span class="has-text-primary-light">Český ráj</span> Vás vítá!
      </div>
      <div class="text">
        Vítejte na stránkách naší rodinné lékárny. Naší prioritou je <span class="has-text-primary-light has-text-weight-bold">Vaše zdraví</span>, proto Vám nabízíme široký výběr léčivých
        přípravků, doplňků stravy a zdravotnických prostředků. V naší lékárně, najdete <span class="has-text-primary-light has-text-weight-bold">vše co potřebujete za výhodné ceny</span>. Náš
        vysoce kvalifikovaný personál Vám ochotně poradí a navrhne léčbu Vašich potíží.
      </div>
    
    </div>
    <div class="centertextm  is-hidden-tablet">
      <div class="logom">
        <img src="../assets/logow.svg" />
      </div>
      <div class="headm title">
        Lékárna <span class="has-text-primary-light">Český ráj</span><br>Vás vítá!
      </div>
      <div class="text">
        Vítejte na stránkách naší rodinné lékárny. Naší prioritou je <span
          class="has-text-primary-light has-text-weight-bold">Vaše zdraví</span>, proto Vám nabízíme široký výběr léčivých
        přípravků, doplňků stravy a zdravotnických prostředků. V naší lékárně, najdete <span
          class="has-text-primary-light has-text-weight-bold">vše co potřebujete za výhodné ceny</span>. Náš
        vysoce kvalifikovaný personál Vám ochotně poradí a navrhne léčbu Vašich potíží.
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
  props: {
  },
  methods: {
    slideto: function() {
      this.$emit("slideto");
    }
  }
}
</script>
<style scoped>
.centertext {
  margin-left: 150px;
  max-width: 768px;
  margin-right: 150px;
}
.centertextm {
  margin-left: 50px;
  margin-right: 50px;
  text-align: center;
}
.buttons {
    -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
      animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation-delay: 3000ms;
}
.text {
  color: white;
  -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  margin-top: 20px;
  margin-bottom: 40px;
  animation-delay: 2900ms;
}
.head
{
  -webkit-animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation-delay: 2700ms;
  font-weight: bold;
  margin-top: 20px;
  color: white;
  font-size: 45px;
}
.headm {
  -webkit-animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation: tracking-in-expand 0.7s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  animation-delay: 2700ms;
  font-weight: bold;
  margin-top: 20px;
  color: white;
  font-size: 25px;
}
.logo img
{
 
  width: 100px;
  -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation-delay: 2600ms;
}
.logom img {
 
  width: 70px;
  -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation-delay: 2600ms;
}
.slide {
  display: flex;
  flex-direction: column;
  justify-content:center;
  background-image: url("../assets/back_w.jpg");

  -webkit-animation: bg-pan-left 28s infinite alternate both;
  animation: bg-pan-left 28s infinite alternate both;
}
 @media screen and (max-width: 768px) {

  .slide {
      display: block;
      padding-top: 5rem;
      
    }
 }
</style>
